import Vue from 'vue';
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist';

import generalModule from '@/stores/generalModule';
import searchModule from './searchModule';
import mainModule from './mainModule';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: process.env.VUE_APP_TITLE,
  storage: window.localStorage,
  modules: ['main'],
});

const vuexSession = new VuexPersistence({
  key: process.env.VUE_APP_TITLE,
  storage: window.sessionStorage,
  modules: ['search'],
});

const store = new Vuex.Store({
  modules: {
    main: mainModule,
    search: searchModule,
    general: generalModule,
  },

  plugins: [vuexLocal.plugin, vuexSession.plugin],
});

export default store;
